import React, { useState, useEffect } from 'react';
import { Pagination } from '@mui/material';
import { useCourse } from '../../pages/course/hooks';

export const DiagnosticPagination = () => {
    const { loadCourses, pagination } = useCourse();
    const { pageNo, pageSize, totalPages } = pagination;

    const [page, setPage] = useState(1);

    const handlePageChange = (event, value) => {
        loadCourses({
            category: 'Diagnostic',
            pageNo: value - 1, // backend pagination is 0-based
            // Keep the current page size (e.g. 8 in grid view) across page changes.
            ...(pageSize ? { pageSize } : {}),
        });
    };

    useEffect(() => {
        if (!pageNo) return setPage(1);
        setPage(pageNo + 1);
    }, [pageNo])

    return (
        <div style={styles.paginationContainer}>
            <Pagination
                count={(totalPages || 1)}
                page={page}
                onChange={handlePageChange}
                color="primary"
            />
        </div>
    );
};


const styles = {
    paginationContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '1rem'
    }
}